import User from '@/Models/User';
import Store from '@/Models/Store';
import Budget from '@/Models/Budget';
import BudgetEntry from '@/Models/BudgetEntry';
import Extrapolation from '@/Models/Extrapolation';
import Projection from '@/Models/Projection';
import ProfitAndLoss from '@/Models/ProfitAndLoss';
import Actual from '@/Models/Actual';
import Review from '@/Models/Review';

export default class DataHydrator {
    static fromProps(props) {
        let data = {
            ...props,
            storeManager: window.storeManager,
            auth: window.auth,
        };

        // User
        if (props.hasOwnProperty('user') && props.user) {
            data.user = new User(props.user);
        }

        // Stores
        if (props.hasOwnProperty('store') && props.store) {
            data.store = new Store(props.store);
        }

        if (props.hasOwnProperty('stores') && props.stores &&
            Array.isArray(props.stores)) {
            data.stores = props.stores.map(store => {
                return new Store(store);
            });
        }

        // Budgets
        if (props.hasOwnProperty('budget') && props.budget) {
            data.budget = new Budget(props.budget);
        }

        if (props.hasOwnProperty('budgets') && props.budgets &&
            Array.isArray(props.budgets)) {
            data.budgets = props.budgets.map(budget => {
                return new Budget(budget);
            });
        }

        // Budget Entries
        if (props.hasOwnProperty('budgetEntry') && props.budgetEntry) {
            data.budgetEntry = new BudgetEntry(props.budgetEntry);
        }

        if (props.hasOwnProperty('budgetEntries') && props.budgetEntries &&
            Array.isArray(props.budgetEntries)) {
            data.budgetEntries = props.budgetEntries.map(budgetEntry => {
                return new BudgetEntry(budgetEntry);
            });
        }

        // Reviews
        if (props.hasOwnProperty('review') && props.review) {
            data.review = new Review(props.review);
        }

        if (props.hasOwnProperty('reviews') && props.reviews &&
            Array.isArray(props.reviews)) {
            data.reviews = props.reviews.map(budget => {
                return new Review(budget);
            });
        }

        // Extrapolations
        if (props.hasOwnProperty('extrapolation') && props.extrapolation) {
            data.extrapolation = new Extrapolation(props.extrapolation);
        }

        if (props.hasOwnProperty('extrapolations') && props.extrapolations &&
            Array.isArray(props.extrapolations)) {
            data.extrapolations = props.extrapolations.map(extrapolation => {
                return new Extrapolation(extrapolation);
            });
        }

        // Projections
        if (props.hasOwnProperty('projection') && props.projection) {
            data.projection = new Projection(props.projection);
        }

        if (props.hasOwnProperty('projections') && props.projections &&
            Array.isArray(props.projections)) {
            data.projections = props.projections.map(projection => {
                return new Projection(projection);
            });
        }

        // Profit and Loss
        if (props.hasOwnProperty('profitAndLoss') && props.profitAndLoss) {
            data.profitAndLoss = new ProfitAndLoss(props.profitAndLoss);
        }

        if (props.hasOwnProperty('profitAndLosses') && props.profitAndLosses &&
            Array.isArray(props.profitAndLosses)) {
            data.profitAndLosses = props.profitAndLosses.map(profitAndLoss => {
                return new ProfitAndLoss(profitAndLoss);
            });
        }

        // Actuals
        if (props.hasOwnProperty('actual') && props.actual) {
            data.actual = new Actual(props.actual);
        }

        if (props.hasOwnProperty('actuals') && props.actuals &&
            Array.isArray(props.actuals)) {
            data.actuals = props.actuals.map(actual => {
                return new Actual(actual);
            });
        }

        return data;
    }
}
